// extracted by css-extract-rspack-plugin
export default {"root":"root-Bx26F4","loading":"loading-Uly4TO"};